import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import store from '@/store/store'
import { useI18n } from 'vue-i18n-composable'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import LexonAutocompleteComponent from '@/components/forms/fields/LexonAutocomplete/LexonAutocompleteComponent.vue'
import LexonTextFieldComponent from '@/components/forms/fields/LexonTextField/LexonTextFieldComponent.vue'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateExpedientDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: { id: string; name: string }
};

const { t } = useI18n()



const expedientName = ref(`DUPLICADO - ${props.componentProps.name}`)
const selectedSections = ref([])

const texts = {
  allSections: t('action_buttons.select_all'),
  explanation: t('components.duplicate_expedient.explanation'),
  nameLabel: t('components.duplicate_expedient.name_label'),
  sectionsLabel: t('components.duplicate_expedient.sections_label'),
  title: t('components.duplicate_expedient.title')
}

const sections = computed(() => store.getters[`${ModuleNamespaces.EXPEDIENTS}/getExpedientSectionsToDuplicate`])

const disabledActionButton = computed(() => !selectedSections.value.length || !expedientName.value)

onMounted(async () => {
  await store.dispatch(`${ModuleNamespaces.EXPEDIENTS}/fetchExpedientSectionsToDuplicate`)
  expedientName.value = `DUPLICADO - ${props.componentProps.name}`
})

const duplicateExpedient = () => {
  const expedientData = {
    id: props.componentProps.id,
    name: expedientName.value,
    sections: selectedSections.value,
    originalName: props.componentProps.name
  }
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
  store.dispatch(`${ModuleNamespaces.EXPEDIENTS}/duplicateExpedient`, expedientData)
}

return { __sfc: true,t, props, expedientName, selectedSections, texts, sections, disabledActionButton, duplicateExpedient, CustomDialogActionButtonsComponent, CustomDialogHeaderComponent, LexonAutocompleteComponent, LexonTextFieldComponent }
}

})